// extracted by mini-css-extract-plugin
module.exports = {"root":"Select_root__MCaBG"};